/* Bulk Quote — vanilla ES5. Spec: _context/specs/2026-04-25-shopify-bulk-quote-form-design.md */
(function () {
  'use strict';

  var STORAGE_KEY = 'ccs-bq-state-v1';
  var CONTACT_EMAIL_FALLBACK = 'orders@cleancaresupplies.ca';

  // Reads canonical Google Ads UTM params from the URL into a flat object.
  // Allowlist keeps the email-attribution surface narrow; non-UTM keys are skipped.
  function readUtms() {
    var out = {}, keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
    var qs = (window.location.search || '').replace(/^\?/, '').split('&');
    var i, eq, k, v;
    for (i = 0; i < qs.length; i++) {
      eq = qs[i].indexOf('=');
      if (eq <= 0) continue;
      k = decodeURIComponent(qs[i].slice(0, eq));
      if (keys.indexOf(k) === -1) continue;
      v = decodeURIComponent(qs[i].slice(eq + 1).replace(/\+/g, ' '));
      out[k] = v;
    }
    return out;
  }

  var state = {
    selections: {},
    contact: { email: '', name: '', company: '' },
    qualification: { industry: '', postal: '', volume: '', currentVendor: '' },
    turnstileToken: ''
  };
  window.bulkQuoteState = state;

  var modalEl, formEl, page, isTrade, currentStep;

  /* ---------- persistence ---------- */
  function loadState() {
    try {
      var raw = window.ccsSS.get(STORAGE_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        if (parsed.selections) state.selections = parsed.selections;
        if (parsed.contact) state.contact = parsed.contact;
        if (parsed.qualification) state.qualification = parsed.qualification;
      }
    } catch (e) { /* ignore */ }
  }
  function persistState() {
    try {
      window.ccsSS.set(STORAGE_KEY, JSON.stringify({
        selections: state.selections,
        contact: state.contact,
        qualification: state.qualification
      }));
    } catch (e) { /* ignore */ }
  }

  /* ---------- selection helpers ---------- */
  function setQty(variantId, qty, rowEl) {
    qty = Math.max(0, Math.min(9999, parseInt(qty, 10) || 0));

    if (qty === 0) {
      delete state.selections[variantId];
    } else {
      state.selections[variantId] = {
        qty: qty,
        name: rowEl.getAttribute('data-product-name') || '',
        tier: rowEl.getAttribute('data-tier') || '',
        listPrice: parseFloat(rowEl.getAttribute('data-list-price')) || null
      };
    }
    persistState();
    renderRow(rowEl, qty);
    renderCart();
  }

  function renderRow(rowEl, qty) {
    var input = rowEl.querySelector('.ccs-bq-row__qty-input');
    var checkbox = rowEl.querySelector('.ccs-bq-row__checkbox');
    if (input) input.value = qty;
    if (checkbox) checkbox.checked = qty > 0;
    rowEl.classList.toggle('ccs-bq-row--selected', qty > 0);
  }

  function renderCart() {
    var keys = Object.keys(state.selections);
    var count = keys.length;
    var totalQty = 0;
    var i; for (i = 0; i < keys.length; i++) totalQty += state.selections[keys[i]].qty;

    var countEl = document.querySelector('[data-bq-count]');
    var totalEl = document.querySelector('[data-bq-total-qty]');
    var ctaEl = document.getElementById('ccs-bq-submit-open');
    var listEl = document.querySelector('[data-bq-rail-list]');

    if (countEl) countEl.textContent = count;
    if (totalEl) totalEl.textContent = totalQty;
    if (ctaEl) ctaEl.disabled = count === 0;

    if (listEl) {
      listEl.innerHTML = '';
      for (i = 0; i < keys.length; i++) {
        var sel = state.selections[keys[i]];
        var li = document.createElement('li');
        li.textContent = sel.qty + '× ' + sel.name;
        listEl.appendChild(li);
      }
    }
  }

  /* ---------- bind row events ---------- */
  function bindRow(rowEl) {
    var variantId = rowEl.getAttribute('data-variant-id');
    var input = rowEl.querySelector('.ccs-bq-row__qty-input');
    var dec = rowEl.querySelector('.ccs-bq-row__qty-btn--dec');
    var inc = rowEl.querySelector('.ccs-bq-row__qty-btn--inc');
    var checkbox = rowEl.querySelector('.ccs-bq-row__checkbox');

    if (dec) dec.addEventListener('click', function () {
      setQty(variantId, (parseInt(input.value, 10) || 0) - 1, rowEl);
    });
    if (inc) inc.addEventListener('click', function () {
      setQty(variantId, (parseInt(input.value, 10) || 0) + 1, rowEl);
    });
    if (input) input.addEventListener('change', function () {
      setQty(variantId, input.value, rowEl);
    });
    if (checkbox) checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        setQty(variantId, Math.max(parseInt(input.value, 10) || 1, 1), rowEl);
      } else {
        setQty(variantId, 0, rowEl);
      }
    });

    var saved = state.selections[variantId];
    if (saved) renderRow(rowEl, saved.qty);
  }

  /* ---------- modal logic ---------- */
  function modalRefs() {
    modalEl = document.getElementById('ccs-bq-modal');
    formEl = document.getElementById('ccs-bq-form');
    page = document.querySelector('.ccs-bq-page');
    isTrade = !!(page && page.getAttribute('data-is-trade') === 'true');
  }

  function setStep(step) {
    currentStep = step;
    var steps = formEl.querySelectorAll('[data-bq-step]');
    var i; for (i = 0; i < steps.length; i++) {
      steps[i].hidden = parseInt(steps[i].getAttribute('data-bq-step'), 10) !== step;
    }
    var backBtn = formEl.querySelector('[data-bq-back]');
    var nextBtn = formEl.querySelector('[data-bq-next]');
    var submitBtn = formEl.querySelector('[data-bq-submit]');
    if (backBtn) backBtn.hidden = step === 1;
    if (nextBtn) nextBtn.hidden = step === 3;
    if (submitBtn) submitBtn.hidden = step !== 3;

    if (step === 3) renderReview();
  }

  function nextStep() {
    if (currentStep === 1) {
      if (!validateStep1()) return;
      setStep(isTrade ? 3 : 2);
    } else if (currentStep === 2) {
      capture('qualification');
      setStep(3);
    }
  }
  function backStep() {
    if (currentStep === 3) setStep(isTrade ? 1 : 2);
    else if (currentStep === 2) setStep(1);
  }

  function validateStep1() {
    capture('contact');
    var errors = [];
    if (!state.contact.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.contact.email)) errors.push('Enter a valid email.');
    if (!state.contact.name) errors.push('Name is required.');
    if (!state.contact.company) errors.push('Company is required.');
    showFormError(errors.join(' '));
    return errors.length === 0;
  }

  function capture(target) {
    var fd = new FormData(formEl);
    if (target === 'contact') {
      state.contact = {
        email: (fd.get('email') || '').toString().trim(),
        name: (fd.get('name') || '').toString().trim(),
        company: (fd.get('company') || '').toString().trim()
      };
    } else if (target === 'qualification') {
      state.qualification = {
        industry: (fd.get('industry') || '').toString().trim(),
        postal: (fd.get('postal') || '').toString().trim(),
        volume: (fd.get('volume') || '').toString().trim(),
        currentVendor: (fd.get('currentVendor') || '').toString().trim()
      };
    }
    persistState();
  }

  function showFormError(msg) {
    var el = formEl.querySelector('[data-bq-form-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function renderReview() {
    var listEl = formEl.querySelector('[data-bq-review-list]');
    if (!listEl) return;
    listEl.innerHTML = '';
    var keys = Object.keys(state.selections);
    var i; for (i = 0; i < keys.length; i++) {
      var sel = state.selections[keys[i]];
      var li = document.createElement('li');
      var priceLabel = sel.tier === 'commodity' && sel.listPrice ? ' (list $' + sel.listPrice.toFixed(2) + ')' : ' (quote)';
      li.textContent = sel.qty + '× ' + sel.name + priceLabel;
      listEl.appendChild(li);
    }
  }

  function openModal() {
    if (Object.keys(state.selections).length === 0) {
      var err = document.getElementById('ccs-bq-cart-error');
      if (err) {
        err.hidden = false;
        setTimeout(function () { err.hidden = true; }, 3000);
      }
      return;
    }
    modalRefs();
    if (!modalEl) return;
    modalEl.hidden = false;
    setStep(1);
    var panel = modalEl.querySelector('.ccs-bq-modal__panel');
    if (panel) panel.focus();
  }

  function closeModal() {
    if (modalEl) modalEl.hidden = true;
  }

  function bindModal() {
    modalRefs();
    if (!modalEl || !formEl) return;

    var openBtn = document.getElementById('ccs-bq-submit-open');
    if (openBtn) openBtn.addEventListener('click', openModal);

    var closers = modalEl.querySelectorAll('[data-bq-close]');
    var i; for (i = 0; i < closers.length; i++) closers[i].addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl && !modalEl.hidden) closeModal();
    });

    var nextBtn = formEl.querySelector('[data-bq-next]');
    var backBtn = formEl.querySelector('[data-bq-back]');
    if (nextBtn) nextBtn.addEventListener('click', nextStep);
    if (backBtn) backBtn.addEventListener('click', backStep);

    formEl.addEventListener('submit', onSubmit);
  }

  /* ---------- submit ---------- */
  function onSubmit(e) {
    e.preventDefault();
    showFormError('');

    var hp = formEl.querySelector('input[name="hp_company_url"]');
    if (hp && hp.value) {
      /* Silent honeypot — fake-success for bots */
      showSuccess();
      return;
    }

    if (!state.turnstileToken) {
      showFormError('Please complete the verification challenge before submitting.');
      return;
    }

    var submitBtn = formEl.querySelector('[data-bq-submit]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
    }

    var body = buildEmailBody();
    var subject = buildSubject();

    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', state.contact.email);
    fd.append('contact[name]', state.contact.name);
    fd.append('contact[subject]', subject);
    fd.append('contact[body]', body);
    fd.append('contact[hp_company_url]', hp ? hp.value : '');
    fd.append('cf-turnstile-response', state.turnstileToken);

    fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (resp) {
        if (!resp.ok) throw new Error('Submission failed (' + resp.status + ')');
        showSuccess();
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Request';
        }
        showFormError(err.message || ('Something went wrong. Please try again or email ' + CONTACT_EMAIL_FALLBACK + '.'));
      });
  }

  function buildSubject() {
    var count = Object.keys(state.selections).length;
    var prefix = isTrade ? '[Reorder]' : '[Bulk Quote]';
    return prefix + ' ' + state.contact.company + ' — ' + count + ' SKUs';
  }

  function buildEmailBody() {
    var lines = [];
    lines.push('Contact: ' + state.contact.name + ' <' + state.contact.email + '>');
    lines.push('Company: ' + state.contact.company);
    lines.push('');

    if (isTrade) {
      lines.push('[reorder] — existing trade customer');
      lines.push('');
    } else {
      var q = state.qualification;
      if (q.industry || q.postal || q.volume || q.currentVendor) {
        if (q.industry) lines.push('Industry: ' + q.industry);
        if (q.postal) lines.push('Delivery postal: ' + q.postal);
        if (q.volume) lines.push('Monthly cleaning-supply spend: ' + q.volume);
        if (q.currentVendor) lines.push('Current vendor: ' + q.currentVendor);
        lines.push('');
      }
    }

    lines.push('| SKU | Name | Tier | Qty | ' + (isTrade ? 'Your price' : 'List price') + ' |');
    lines.push('|-----|------|------|-----|------------|');
    var keys = Object.keys(state.selections);
    var i; for (i = 0; i < keys.length; i++) {
      var sel = state.selections[keys[i]];
      var price = sel.tier === 'commodity' && sel.listPrice ? '$' + sel.listPrice.toFixed(2) : '(quote)';
      lines.push('| ' + keys[i] + ' | ' + sel.name + ' | ' + sel.tier + ' | ' + sel.qty + ' | ' + price + ' |');
    }
    lines.push('');
    var utm = readUtms();
    var utmKeys = Object.keys(utm);
    var hasUtm = false, u;
    for (u = 0; u < utmKeys.length; u++) {
      if (utm[utmKeys[u]]) { hasUtm = true; break; }
    }
    if (hasUtm) {
      lines.push('Source attribution:');
      for (u = 0; u < utmKeys.length; u++) {
        if (utm[utmKeys[u]]) {
          lines.push('  ' + utmKeys[u] + '=' + utm[utmKeys[u]]);
        }
      }
      lines.push('');
    }
    lines.push('Submitted: ' + new Date().toISOString());
    lines.push('Source: /pages/bulk-quote');
    return lines.join('\n');
  }

  function showSuccess() {
    var successEl = document.getElementById('ccs-bq-success');
    var preEl = successEl ? successEl.querySelector('[data-bq-success-copy]') : null;
    if (preEl) preEl.textContent = buildEmailBody();

    closeModal();
    if (successEl) successEl.hidden = false;

    state.selections = {};
    persistState();
    renderCart();
    var rows = document.querySelectorAll('.ccs-bq-row');
    var i; for (i = 0; i < rows.length; i++) renderRow(rows[i], 0);

    if (successEl && successEl.scrollIntoView) successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Turnstile callback exposed at window scope */
  window.ccsBqOnTurnstileResolved = function (token) {
    state.turnstileToken = token || '';
    var submitBtn = document.querySelector('[data-bq-submit]');
    if (submitBtn) submitBtn.disabled = !token;
  };

  /* ---------- init ---------- */
  function init() {
    loadState();
    var rows = document.querySelectorAll('.ccs-bq-row');
    var i; for (i = 0; i < rows.length; i++) bindRow(rows[i]);
    renderCart();
    bindModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ccsBulkQuote = {
    state: state,
    persistState: persistState,
    renderCart: renderCart
  };
})();
